import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentOrder: null,
  orderHistory: [],
  checkout: {
    service: null,
    configuration: null,
    totalPrice: 0,
    paymentInfo: {
      nom: '',
      email: '',
      telephone: ''
    }
  },
  paymentStatus: 'idle', // idle, processing, success, failed
  loading: false,
  error: null
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    createOrder: (state, action) => {
      const { service, configuration, price } = action.payload;
      state.currentOrder = {
        id: Date.now().toString(),
        service,
        configuration,
        price,
        status: 'pending',
        createdAt: new Date().toISOString()
      };
    },
    updateCheckout: (state, action) => {
      const { service, configuration, totalPrice } = action.payload;
      state.checkout = {
        ...state.checkout,
        service,
        configuration,
        totalPrice
      };
    },
    updatePaymentInfo: (state, action) => {
      const { field, value } = action.payload;
      state.checkout.paymentInfo[field] = value;
    },
    setPaymentStatus: (state, action) => {
      state.paymentStatus = action.payload;
    },
    submitOrder: (state) => {
      if (state.currentOrder) {
        state.currentOrder.status = 'submitted';
        state.orderHistory.push(state.currentOrder);
      }
    },
    completeOrder: (state, action) => {
      const orderId = action.payload;
      const order = state.orderHistory.find(o => o.id === orderId);
      if (order) {
        order.status = 'completed';
        order.completedAt = new Date().toISOString();
      }
    },
    resetCheckout: (state) => {
      state.checkout = initialState.checkout;
      state.paymentStatus = 'idle';
      state.currentOrder = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const {
  createOrder,
  updateCheckout,
  updatePaymentInfo,
  setPaymentStatus,
  submitOrder,
  completeOrder,
  resetCheckout,
  setLoading,
  setError
} = orderSlice.actions;

export default orderSlice.reducer;
